import { useCallback } from 'react';
import { useQuery } from 'react-query';
import { ORGANIZATION } from '../constants/queryDefinition';
import DealerService from '../../services/DealerService';

const useOrganizationDealer = (companyId: number) => {
  const getOrganizationDealer = useCallback(async () => {
    const dealerService = DealerService.get();
    const response = await dealerService.getOrganizationDealer(companyId);

    return response;
  }, [companyId]);

  return useQuery(
    [ORGANIZATION.GETDEALER.KEY, companyId],
    getOrganizationDealer,
    {
      enabled: !!companyId,
      retry: false
    }
  );
};

export default useOrganizationDealer;
